import { ControlType, Property, PropertyType } from "../../../base/types";
import { getSpacingClasses, textStyleClasses } from "../../../base/styles/helpers";

import Accordion from "react-bootstrap/esm/Accordion";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";

export const AccordionItemComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const title: string | undefined = properties[Property.Heading];

    const spacingClasses = getSpacingClasses(control.styles?.spacing);

    const style = {
        "--bs-accordion-btn-bg": control.styles?.background?.color || "var(--kt-accordion-button-bg)",
        "--bs-accordion-active-bg": control.styles?.background?.color || "var(--kt-accordion-button-active-bg)",
        "--bs-accordion-active-color": "--",
        "--bs-accordion-btn-padding": spacingClasses || "1.5rem",
        "--bs-accordion-btn-padding-x": spacingClasses || "1.5rem",
        "--bs-accordion-btn-padding-y": spacingClasses || "1.5rem",
    } as React.CSSProperties;

    const textClasses = textStyleClasses(control.styles?.text)

    return (
        <Accordion.Item eventKey={control.controlId}>
            <Accordion.Header className={className} style={style}>
                <span className={textClasses}>{title}</span>
            </Accordion.Header>
            <Accordion.Body>
                {children}
            </Accordion.Body>
        </Accordion.Item>)
}

Registry.addControl({
    id: "fc9e4e07-e8af-4bbf-97ff-29cbc1ab1d30",
    name: "Accordion Item",
    type: ControlType.AccordionItem,
    properties: [
        { id: Property.Heading, name: 'Title', type: PropertyType.String },
    ],
    component: AccordionItemComponent
})
